module.exports = __webpack_public_path__ + "static/media/star-empty.f2485830.png";